import React, { useEffect, useState } from 'react'
import { Box, Button, Divider, Paper, Flex, Text, TextInput, SimpleGrid, ActionIcon, Table, Image, NumberInput, Modal, Group, Tabs, FileInput, Tooltip } from '@mantine/core'
import { useSelector } from 'react-redux'
import { editProduct } from '../../../../services/products'
import { notificationError, notificationSuccess } from '../../../ui/Notifications'
import { IconTrash, IconPlus, IconArrowBigRight } from '@tabler/icons-react'
import NoImage from '../../../../assets/img/images/no-images.png'
import { validation } from '../../../../plugins/validation'
import { modals } from '@mantine/modals'
import SearchMascot from '../../../../assets/img/mascot/18.png'
import { convertFileToImageVariant } from '../../../../services/products'

const variantValidation = {
  option: {
    isError: false,
    message: ''
  },
  value: {
    isError: false,
    message: ''
  }
}

const generateVariantValidation = {
  quantity: {
    isError: false,
    message: ''
  },
  price: {
    isError: false,
    message: ''
  },
  sale_price: {
    isError: false,
    message: ''
  },
  reseller_price: {
    isError: false,
    message: ''
  },
  ali_sku: {
    isError: false,
    message: ''
  },
}


const ProductVariants = ({ productId, reloadProduct }) => {
  const { isLoadingProduct, summary, minimumPayload, variants, prices } = useSelector(state => state.product_detail)
  const [validationVariant, setValidationVariant] = useState(variantValidation)
  const [validationGenerateVariant, setValidationGenerateVariant] = useState(generateVariantValidation)
  const [enableVariant, setEnableVariant] = useState(false)
  const [generateDataVariant, setGenerateDataVariant] = useState(false)
  const [variant, setVariant] = useState([])
  const [generateVariant, setGenerateVariant] = useState([])
  // service
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [modalAdjustImageVariant, setModalAdjustImageVariant] = useState(false)
  const [selectedIndexValueVariant, setSelectedIndexValueVariant] = useState(null)
  const [selectedMethodAdjustImage, setSelectedMethodAdjustImage] = useState('url')
  const [recentImage, setRecentImage] = useState(null)
  const [uploadImage, setUploadImage] = useState(null)
  const [updatedImage, setUpdatedImage] = useState('')

  const promptRevertSetVariant = () => {
    return modals.openConfirmModal({
      centered: 'true',
      closeOnConfirm: false,
      withCloseButton: false,
      size: 'lg',
      children: (
        <Box>
          <Box ta='center'>
            <Image src={SearchMascot} fit='contain' h='180' my={20} />
            <Text fw={500} mb={4}>Are you sure you want to revert to set variant? </Text>
            <Text fz='sm' c='gray.6' mb={20}>Revert to set variant will change the previously generated variant data. This action cannot be undone.</Text>
          </Box>
        </Box>
      ),
      labels: { confirm: 'Revert Now', cancel: "Cancel" },
      confirmProps: { color: 'red' },
      onConfirm: () => [setGenerateDataVariant(false), modals.closeAll()],
    })
  }

  const handlingSetForm = (dataVariant) => {
    if (dataVariant.structure.length > 0) {
      setEnableVariant(true)
      setVariant(dataVariant.structure)
    }
    if (dataVariant.sku.length > 0) {
      setGenerateDataVariant(true)
      setGenerateVariant(dataVariant.sku)
    }
  }

  useEffect(() => {
    if (!isLoadingProduct && variants) {
      handlingSetForm(variants)
    }
    // eslint-disable-next-line
  }, [isLoadingProduct, variants])

  useEffect(() => {
    if (uploadImage === null) {
      setUpdatedImage('')
    }
  }, [uploadImage])

  // service
  const generatePayload = () => {
    return {
      ...minimumPayload,
    }
  }

  const handleSubmit = async () => {
    setLoadingSubmit(true)
    setValidationVariant(variantValidation)
    setValidationGenerateVariant(generateVariantValidation)
    const payload = generatePayload()
    if (!enableVariant) {
      payload.skus = []
    } else {
      if (!generateDataVariant) {
        notificationError('Update Variant Product Failed', 'Please set data of variant product first')
        setLoadingSubmit(false)
        return
      }
      const dataVariant = generateVariant
      let validateVariant = {}
      for (let i = 0; i < dataVariant.length; i++) {
        validateVariant = {
          quantity: `${dataVariant[i].quantity}`,
          price: `${dataVariant[i].price}`,
          sale_price: `${dataVariant[i].sale_price}`,
          reseller_price: `${dataVariant[i].reseller_price}`,
          ali_sku: `${dataVariant[i].ali_sku}`,
        }
      }
      const isErrorVariant = validation(validateVariant, setValidationGenerateVariant)
      if (isErrorVariant) {
        notificationError('Update Variant Product Error', 'Please recheck your form variant')
        setLoadingSubmit(false)
        return
      }
      const generatedVariantStructure = variant.map((val) => {
        return {
          option: val.option,
          value: val.value.flatMap((optionValue) => {
            return [optionValue]
          }),
        }
      })

      const generatedAttributes = generatedVariantStructure.flatMap((variant) => {
        return variant.value.map((data) => {
          return {
            key_id: '',
            key: variant.option,
            value: data,
            value_id: null,
            property: '',
            image_url: '',
            original_key: '',
            original_value: data,
          }
        })
      })
      payload.attributes = generatedAttributes
      payload.skus = generateVariant
    }
    try {
      const response = await editProduct(productId, payload)
      if (response.success) {
        notificationSuccess('Update Variant Product Success', 'Update variant product successfully')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Product Error', `${errorMessage ? errorMessage : 'Please contact your administrator'}`)
    } finally {
      setLoadingSubmit(false)
      reloadProduct()
    }
  }

  const renderButtonUpdate = () => {
    const buttonStyle = {
      position: 'fixed',
      bottom: '25px',
      right: '55px',
      padding: '10px',
      zIndex: 1000,
    }
    return (
      <Button
        size='sm'
        style={buttonStyle}
        loading={loadingSubmit}
        loaderProps={{ type: 'dots' }}
        onClick={() => handleSubmit()}
      >
        Update
      </Button>
    )
  }

  const handlingToggleVariant = () => {
    if (!enableVariant) {
      if (prices && prices.enablePricing && prices.pricingType === 'bulkPrice') {
        return modals.openConfirmModal({
          centered: 'true',
          withCloseButton: false,
          size: 'lg',
          children: (
            <Box>
              <Box ta='center'>
                <Image src={SearchMascot} fit='contain' h='180' my={20} />
                <Text fw={500} mb={4}>Wait, you can't do that!</Text>
                <Text fz='sm' c='gray.6' mb={20}>You cannot enable variants while Bundle Price is active. Please disable Bundle Price in the "Wholesale and Bundle Price" section first.</Text>
              </Box>
            </Box>
          ),
          labels: { confirm: 'Understand', cancel: "Close" },
          confirmProps: { color: 'blue' },
          onConfirm: () => modals.closeAll(),
        })
      }

      setEnableVariant(true)
      setValidationVariant(variantValidation)
      setValidationGenerateVariant(generateVariantValidation)
      const data = variant
      const generateFormVariant = {
        option: '',
        value: ['']
      }
      data.push(generateFormVariant)
      setVariant(data)
    } else {
      setEnableVariant(false)
      setVariant([])
      setGenerateDataVariant(false)
    }
  }

  const handleAddVariant = () => {
    setValidationVariant(variantValidation)
    setValidationGenerateVariant(generateVariantValidation)
    const data = [...variant]
    const generateFormVariant = {
      option: '',
      value: ['']
    }
    data.push(generateFormVariant)
    setVariant(data)
  }

  const handleRemoveVariant = (indexVariant) => {
    setValidationVariant(variantValidation)
    setValidationGenerateVariant(generateVariantValidation)

    const dataVariant = [...variant]
    dataVariant.splice(indexVariant, 1)
    setVariant(dataVariant)
  }

  const handleChangeVariant = (indexVariant, labelName, value) => {
    const formVariant = variant
    const remapForm = formVariant.map((val, index) => {
      if (index === indexVariant) {
        return {
          ...val,
          [labelName]: value
        }
      } else {
        return val
      }
    })
    setVariant(remapForm)
  }

  const handleAddValueVariant = (indexVariant) => {
    setValidationVariant(variantValidation)
    setValidationGenerateVariant(generateVariantValidation)
    const dataVariant = [...variant]
    const valueVariant = dataVariant[indexVariant].value
    valueVariant.push('')
    setVariant(dataVariant)
  }

  const handleRemoveValueVariant = (indexVariant, indexValueVariant) => {
    setValidationVariant(variantValidation)
    setValidationGenerateVariant(generateVariantValidation)
    const dataVariant = [...variant]
    const newData = dataVariant.map((val, index) => {
      if (index === indexVariant) {
        const renewValueOption = val.value.filter((val, index) => index !== indexValueVariant)
        return {
          ...val,
          value: renewValueOption
        }
      }
      return val
    })

    setVariant(newData)
  }

  const handleChangeValueVariant = (indexVariant, indexValue, value) => {
    const dataVariant = [...variant]
    dataVariant[indexVariant].value[indexValue] = value
    setVariant(dataVariant)
  }

  const handleOpenModalAdjustImageVariant = (indexValueVariant, value) => {
    setSelectedIndexValueVariant(indexValueVariant)
    setModalAdjustImageVariant(true)
    setRecentImage(value.image_url)
  }

  const onCloseModalAdjustImageVariant = () => {
    setSelectedIndexValueVariant(null)
    setModalAdjustImageVariant(false)
    setRecentImage(null)
    setUpdatedImage('')
    setUploadImage(null)
    setSelectedMethodAdjustImage('url')
  }

  const submitUpdateVariantImage = () => {
    handleChangeGenerateVariant(selectedIndexValueVariant, `image_url`, updatedImage)
    onCloseModalAdjustImageVariant()
  }

  const handleConvertToURL = async (val) => {
    const fileImage = val

    const formData = new FormData()
    formData.append(`image`, fileImage)
    try {
      const response = await convertFileToImageVariant(formData)
      if (response.success) {
        setUploadImage(val)
        setUpdatedImage(response.image_url)
      } else {
        notificationError('Failed To Convert Image Variant', 'Please contact your administrator')
      }
    } catch (error) {
      console.log(error)
      notificationError('Failed To Convert Image Variant', 'Please contact your administrator')
    }
  }

  const handleChangeGenerateVariant = (indexVariant, labelName, value) => {
    const formVariant = [...generateVariant]
    const remapForm = formVariant.map((val, index) => {
      if (index === indexVariant) {
        return {
          ...val,
          [labelName]: value
        }
      } else {
        return val
      }
    })
    setGenerateVariant(remapForm)
  }

  const checkDataValueOptionVariant = (arr) => {
    return arr.some(item => typeof item === 'string' && item.trim().length === 0)
  }

  const variantGenerator = (array) => {
    return array.reduce(
      function (a, b) {
        return a
          .map(function (x) {
            return b.map(function (y) {
              return x.concat([y])
            })
          })
          .reduce(function (a, b) {
            return a.concat(b)
          }, [])
      },
      [[]]
    )
  }

  const intersectionByNative = (existingSkus, identifier, property) => {
    return existingSkus.filter(sku =>
      identifier.some(ident => sku[property] === ident[property])
    )
  }

  const mergeArraysByKey = (arr1, arr2, key) => {
    // Key the first array using the common property
    const keyedArr1 = arr1.reduce((acc, item) => {
      acc[item[key]] = item
      return acc
    }, {});

    // Key the second array
    const keyedArr2 = arr2.reduce((acc, item) => {
      acc[item[key]] = item
      return acc
    }, {});

    // Merge the two keyed objects using the spread syntax
    const mergedObjects = { ...keyedArr1, ...keyedArr2 }

    // Return the values as a new array
    return Object.values(mergedObjects)
  }

  const handleSetDataVariantProduct = () => {
    setValidationVariant(variantValidation)
    setValidationGenerateVariant(generateVariantValidation)
    const validateOptionVariant = variant.find((val) => val.option === '')
    if (validateOptionVariant !== undefined) {
      setValidationVariant((oldVal) => ({
        ...oldVal, 'option': {
          isError: true,
          message: 'This form is required'
        }
      }))
      notificationError('Generate Data Variant Product Failed', 'Please recheck your form variant name')
      return
    }

    const validateValueOptionVariant = variant.find((val) => checkDataValueOptionVariant(val.value))
    if (validateValueOptionVariant !== undefined) {
      setValidationVariant((oldVal) => ({
        ...oldVal, 'value': {
          isError: true,
          message: 'This form is required'
        }
      }))
      notificationError('Generate Data Variant Product Failed', 'Please recheck your form variant option')
      return
    }
    const generatedVariantStructure = variant.map((val) => {
      return {
        option: val.option,
        value: val.value.flatMap((optionValue) => {
          return [optionValue]
        }),
      }
    })

    const generatedAttributes = generatedVariantStructure.flatMap((variant) => {
      return variant.value.map((data) => {
        return {
          key_id: '',
          key: variant.option,
          value: data,
          value_id: null,
          property: '',
          image_url: '',
          original_key: '',
          original_value: data,
        }
      })
    })

    const groupedAttributes = Object.values(
      generatedAttributes.reduce((acc, obj) => {
        const key = obj.key;
        (acc[key] = acc[key] || []).push(obj);
        return acc;
      }, {})
    )

    const generateVariant = variantGenerator(groupedAttributes)

    const skuProduct = generateVariant.map((val) => {
      return {
        _combinationIdentification:
          val.flatMap((item) => {
            return `${item.key}:${item.value}`
          }).join(';'),
        items: val,
        variant_id: '',
        sku_id: '0',
        ali_sku: 'ALI-',
        price: 0,
        sale_price: 0,
        reseller_price: 0,
        price_strike: '',
        quantity: 0,
        properties: '',
        image_url: 'https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg',
      }
    })

    const identifier = skuProduct.map((val) => {
      return {
        _combinationIdentification: val._combinationIdentification
      }
    })

    const filteredExistingSkuProduct = intersectionByNative(skuProduct, identifier, '_combinationIdentification')
    const mergedSku = mergeArraysByKey(skuProduct, filteredExistingSkuProduct, '_combinationIdentification')
    const finalizeData = Object.values(mergedSku)
    setGenerateVariant(finalizeData)
    setGenerateDataVariant(true)
  }

  const showGenerateVariant = (showGenerate) => {

    const mappingLabelTableVariant = (data) => {
      const remapLabel = data.map((val, index) => {
        return (
          (<Table.Th key={index} width={'auto'}>{val.option}</Table.Th>)
        )
      })
      return remapLabel
    }

    const mappingDataTable = (data) => {

      const mappingVariantValue = (dataValue) => {
        const remapData = dataValue.map((val) => {
          return (<Table.Td>{val.value}</Table.Td>)
        })
        return remapData
      }

      if (data.length > 0) {
        const remapData = data.map((val, index) => {
          return (
            <Table.Tr key={index}>
              <Table.Td>
                <Tooltip label='Click to Change Image' position="right">
                  <Paper shadow="sm" w={62} withBorder radius='md' style={{ cursor: 'pointer' }} onClick={(() => handleOpenModalAdjustImageVariant(index, val))}>
                    <Image w={60} h={60} radius='md' src={val.image_url || NoImage} />
                  </Paper>
                </Tooltip>
              </Table.Td>
              {mappingVariantValue(val.items)}
              <Table.Td>
                <NumberInput
                  name='quantity'
                  value={generateVariant[index].quantity}
                  onChange={(val) => handleChangeGenerateVariant(index, `quantity`, val)}
                  error={validationGenerateVariant.quantity.isError ? `${validationGenerateVariant.quantity.message}` : ''}
                  withAsterisk
                  size='xs'
                  rightSection={<Text fz='xs' c='black' tt='capitalize'>{summary.quantityUnit}</Text>}
                  rightSectionWidth={40}
                />
              </Table.Td>
              <Table.Td>
                <NumberInput
                  name='price'
                  value={generateVariant[index].price}
                  onChange={(val) => handleChangeGenerateVariant(index, `price`, val)}
                  error={validationGenerateVariant.price.isError ? `${validationGenerateVariant.price.message}` : ''}
                  withAsterisk
                  size='xs'
                  leftSection={<Text fz='xs' c='black' tt='capitalize'>{summary.originalCurrency}</Text>}
                  leftSectionWidth={40}
                />
              </Table.Td>
              <Table.Td>
                <NumberInput
                  name='sale_price'
                  value={generateVariant[index].sale_price}
                  onChange={(val) => handleChangeGenerateVariant(index, `sale_price`, val)}
                  error={validationGenerateVariant.sale_price.isError ? `${validationGenerateVariant.sale_price.message}` : ''}
                  withAsterisk
                  size='xs'
                  leftSection={<Text fz='xs' c='black' tt='capitalize'>{summary.originalCurrency}</Text>}
                  leftSectionWidth={40}
                />
              </Table.Td>
              <Table.Td>
                <NumberInput
                  name='reseller_price'
                  value={generateVariant[index].reseller_price}
                  onChange={(val) => handleChangeGenerateVariant(index, `reseller_price`, val)}
                  error={validationGenerateVariant.reseller_price.isError ? `${validationGenerateVariant.reseller_price.message}` : ''}
                  withAsterisk
                  size='xs'
                  leftSection={<Text fz='xs' c='black' tt='capitalize'>{summary.originalCurrency}</Text>}
                  leftSectionWidth={40}
                />
              </Table.Td>
              <Table.Td>
                <TextInput
                  name='ali_sku'
                  value={generateVariant[index].ali_sku}
                  onChange={(val) => handleChangeGenerateVariant(index, `ali_sku`, val.target.value)}
                  error={validationGenerateVariant.ali_sku.isError ? `${validationGenerateVariant.ali_sku.message}` : ''}
                  withAsterisk
                  size='xs'
                />
              </Table.Td>
            </Table.Tr>
          )
        })

        return remapData
      }
    }

    const formAdjustImageVariant = () => {
      return (
        <Box>
          <Tabs
            size='xs'
            my={4}
            variant="pills"
            radius="xl"
            value={selectedMethodAdjustImage}
            onChange={(val) => [setSelectedMethodAdjustImage(val), setUpdatedImage(''), setUploadImage(null)]}>
            <Tabs.List>
              <Tabs.Tab value="url">From URL</Tabs.Tab>
              <Tabs.Tab value="upload">From Local Computer</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value="url">
              <Box my={12}>
                <TextInput
                  name='image_url'
                  value={updatedImage}
                  onChange={(val) => setUpdatedImage(val.target.value)}
                  withAsterisk
                  size='xs'
                />
              </Box>
            </Tabs.Panel>
            <Tabs.Panel value="upload">
              <Box my={12}>
                <FileInput
                  name='image_url'
                  value={uploadImage}
                  onChange={(val) => handleConvertToURL(val)}
                  accept="image/jpeg,image/jpg,image/png"
                  clearable
                  withAsterisk
                  size='xs'
                />
              </Box>
            </Tabs.Panel>
          </Tabs>
          <Box>
            <Text fz='md' fw='500'>Preview Image</Text>
            <Box my={20}>
              <Flex gap="xl" justify="center" align="center">
                <Paper shadow="sm" w={182} withBorder radius='md'>
                  <Image w={180} h={180} radius='md' src={recentImage || NoImage} />
                </Paper>
                <IconArrowBigRight size={30} color='gray' />
                <Paper shadow="sm" w={182} withBorder radius='md'>
                  <Image w={180} h={180} radius='md' src={updatedImage || NoImage} />
                </Paper>
              </Flex>
            </Box>
          </Box>
          <Box mt={20}>
            <Flex justify='flex-end'>
              <Group>
                <Button size='xs' variant="outline" onClick={onCloseModalAdjustImageVariant}>Close</Button>
                <Button size='xs' variant="filled" disabled={updatedImage === ''} onClick={() => submitUpdateVariantImage()}>Update</Button>
              </Group>
            </Flex>
          </Box>
        </Box>
      )
    }

    if (showGenerate) {
      return (
        <Box>
          <Table.ScrollContainer minWidth={1366} type='native'>
            <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
              <Table.Thead style={{ backgroundColor: '#eeefef' }}>
                <Table.Tr>
                  <Table.Th width={120}>Photo</Table.Th>
                  {variant.length > 0 ? mappingLabelTableVariant(variant) : ''}
                  <Table.Th width='auto'>Stock</Table.Th>
                  <Table.Th width='auto'>Price</Table.Th>
                  <Table.Th width='auto'>Sale Price</Table.Th>
                  <Table.Th width='auto'>Dropship Price</Table.Th>
                  <Table.Th width='auto'>SKU</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody style={{ verticalAlign: 'top' }}>
                {mappingDataTable(generateVariant)}
              </Table.Tbody>
            </Table>
          </Table.ScrollContainer>
          <Modal
            opened={modalAdjustImageVariant}
            onClose={onCloseModalAdjustImageVariant}
            centered closeOnClickOutside={false}
            size='lg'
            title={<Text fw='Bold'>Edit Image Variant</Text>}
            withCloseButton={false}
          >
            {selectedIndexValueVariant !== null ? formAdjustImageVariant() : ''}
          </Modal>
        </Box>
      )
    }
  }

  const showFormVariant = () => {

    const mappingValueVariant = (indexVariant, valueVariant) => {
      const remapFormValue = valueVariant.map((values, index) => {
        return (
          <Flex gap='sm' align='center' mb={12}>
            <TextInput
              value={variant[indexVariant].value[index]}
              label={`Variant Option`}
              placeholder='Example: Red, Green, Blue, Small, Medium'
              onChange={(val) => handleChangeValueVariant(indexVariant, index, val.target.value)}
              error={validationVariant.value.isError ? `${validationVariant.value.message}` : ''}
              withAsterisk
              size='sm'
              style={{ flex: '0 0 93%' }}
              disabled={generateDataVariant}
            />
            {index > 0 ? <ActionIcon variant="light" color="red" size="lg" mt={validationVariant.value.isError ? 6 : 24} disabled={generateDataVariant} onClick={() => handleRemoveValueVariant(indexVariant, index)}><IconTrash size={14} /></ActionIcon> : ''}
          </Flex>
        )
      })
      return remapFormValue
    }

    const handleShowFormVariant = () => {
      const remapVariant = variant.map((values, index) => {
        return (
          <Box key={index} mb={8}>
            <SimpleGrid cols={2} verticalSpacing="md" spacing="xs">
              <Box>
                <TextInput
                  value={variant[index].option}
                  label={`Variant Name`}
                  placeholder='Example: Color, Size, Storage'
                  onChange={(val) => handleChangeVariant(index, `option`, val.target.value)}
                  error={validationVariant.option.isError ? `${validationVariant.option.message}` : ''}
                  withAsterisk
                  size='sm'
                  disabled={generateDataVariant}
                  style={{ width: '93%' }}
                />
                <Box mt={8} h={30}>
                  <Button
                    size='compact-xs'
                    variant='outline'
                    leftSection={<IconTrash size={12} />}
                    onClick={() => handleRemoveVariant(index)}
                    disabled={index === 0 || generateDataVariant}
                  >
                    Remove Variant
                  </Button>
                </Box>
              </Box>
              <Box>
                {mappingValueVariant(index, variant[index].value)}
                <Box mt={10} h={30}>
                  <Button
                    size='compact-xs'
                    leftSection={<IconPlus size={12} />}
                    disabled={generateDataVariant}
                    onClick={() => handleAddValueVariant(index)}
                  >
                    Add Variant Option
                  </Button>
                </Box>
              </Box>
            </SimpleGrid>
          </Box>
        )
      })
      return remapVariant
    }

    return (
      <Box>
        <Box my={20}>
          <Flex justify='space-between' align='center'>
            <Text fw={500} mb={10}>
              1.Set Variant
            </Text>
            <Button
              size='xs'
              onClick={() => handleAddVariant()}
              disabled={variant.length > 2 || generateDataVariant}
              leftSection={<IconPlus size={12} />}
            >
              Add Variant ({variant.length} / 3)
            </Button>
          </Flex>
          <Box mb={10}>
            {handleShowFormVariant()}
            <Flex justify='flex-end' mt={20}>
              <Button
                size='xs'
                onClick={() => handleSetDataVariantProduct()}
                disabled={generateDataVariant}
              >
                Set Data of Variant Product
              </Button>
            </Flex>
          </Box>
        </Box>
        <Divider my={10} />
        <Box my={20}>
          <Flex justify='space-between' align='center'>
            <Text fw={500}>
              2.Set Data of Variant Product
            </Text>
            <Button
              size='xs'
              onClick={() => promptRevertSetVariant()}
              disabled={!generateDataVariant}
            >
              Revert to Set Variant
            </Button>
          </Flex>
          <Box my={20}>
            {showGenerateVariant(generateDataVariant)}
          </Box>
        </Box>
      </Box>
    )
  }

  return (
    <Box mb={20} mt={10}>
      <Paper my={'xl'} p={'md'} withBorder shadow="xs" radius="md">
        <Flex justify='space-between' align='center'>
          <Text fw={500}>
            Product Variants
          </Text>
          <Button
            size='xs'
            onClick={() => handlingToggleVariant()}
          >
            {!enableVariant ? 'Enable' : 'Disable'} Variant
          </Button>
        </Flex>
        <Divider my={10} />

        {enableVariant ? showFormVariant() : ''}
      </Paper>

      {renderButtonUpdate()}
    </Box>
  )
}

export default ProductVariants